module.exports = __webpack_public_path__ + "media/images/camera_pause_red-fb60a94b82f590bd1b57e820e8eba270.svg";